import API, { config } from './config'

//Mapa de exceções encontradas na API de CEPs
//Ex: Quixabá na verdade é em PB, mas está retornando como se fosse em PE
//Em PE é Quixaba

const CEP_EXCEPTION_MAP = {
    "56280-000": {
        logradouro: "",
        bairro: "",
        localidade: "Araripina",
        uf: "PE",
    }
}

const CITYS_EXCEPTION_MAP = {
    "QUIXABÁ_PE": "Quixaba",
}

export const CepAPI = {
    async getInfosByCep(cep) {
        if (CEP_EXCEPTION_MAP[cep]) {
            return {
                success: true,
                body: {
                    ...CEP_EXCEPTION_MAP[cep]
                }
            };
        } else {
            try {

                const response = await API.get('https://viacep.com.br/ws/' + cep + '/json/')


                const { localidade, uf } = response.data;
                const exceptionTestCode = `${localidade}_${uf}`.toUpperCase();

                if (CITYS_EXCEPTION_MAP[exceptionTestCode]) {
                    response.data.localidade = CITYS_EXCEPTION_MAP[exceptionTestCode];
                }

                //console.log("RESPONSE: ", response)

                return {
                    success: true,
                    body: response.data
                };


            } catch (error) {

                //console.log("ERROR: ", error)
                return {
                    success: false,
                    body: error.response.data
                };
            }
        }

    }
}